export default __webpack_public_path__ + "static/card-image-2-052c0f2ecd8ff95bbbb9cee157befa0e.jpg";